"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M9.352 26a.667.667 0 0 0-.471 1.139l4.242 4.233L3.8 40.688a.667.667 0 0 0 0 .943L6.368 44.2a.667.667 0 0 0 .943 0l9.322-9.321 4.229 4.221A.667.667 0 0 0 22 38.623V26zm29.296-6a.667.667 0 0 0 .471-1.139l-4.242-4.233L44.2 5.312a.667.667 0 0 0 0-.943L41.632 1.8a.667.667 0 0 0-.943 0l-9.322 9.321L27.138 6.9A.667.667 0 0 0 26 7.377V20z" })
);

